
import _ from 'underscore';

import React from 'react';

import PropTypes from 'prop-types';

import classnames from 'classnames';
import { Modal } from '@bingads-webui-react/primitive';
import { InlineInfoAlert } from '@bingads-webui-cc-react/alert';
import { PidlUtilShape } from '../shapes';
import { ResourceTypes } from '../consts';
import type { ScaChallengerPidlFormProps } from '../types';

export class ScaChallengerPidlForm extends React.Component<ScaChallengerPidlFormProps> {
  static propTypes = {
    paymentSessionData: PropTypes.shape({
      piid: PropTypes.number.isRequired,
      language: PropTypes.string.isRequired,
      partner: PropTypes.string.isRequired,
      amount: PropTypes.number.isRequired,
      currency: PropTypes.string.isRequired,
      country: PropTypes.string.isRequired,
      challengeScenario: PropTypes.string.isRequired,
      challengeWindowSize: PropTypes.string,
    }).isRequired,
    pidlInstance: PropTypes.shape({
      handlePaymentChallenge: PropTypes.func.isRequired,
      handlePurchaseRiskChallenge: PropTypes.func.isRequired,
    }),
    pidlUtil: PidlUtilShape.isRequired,
    pidlFormId: PropTypes.string.isRequired,
    showModal: PropTypes.bool.isRequired,
    modalTitle: PropTypes.string.isRequired,
    onHideModalCallbackHandler: PropTypes.func.isRequired,
    isModern3ds: PropTypes.bool.isRequired,
    modern3dsInfoText: PropTypes.node.isRequired,
    piType: PropTypes.string.isRequired,
    permissions: PropTypes.shape({}),
  };

  static defaultProps: Partial<ScaChallengerPidlFormProps> = {

    pidlInstance: null,
    permissions: {},
  };


  componentDidUpdate(prevProps: ScaChallengerPidlFormProps) {
    if (this.props.pidlInstance !== prevProps.pidlInstance) {
      this.props.pidlUtil.logger.setPidlOption('Market', this.props.paymentSessionData.country);
      this.props.pidlUtil.logger.start('renderPidl');

      if (this.props.piType === 'UPI') {
        this.props.pidlInstance.handlePaymentChallenge(this.props.paymentSessionData);
      } else if (this.props.paymentSessionData.country === 'IN' && this.props.isModern3ds) {
        const riskChallengeParams = {
          piResourceInfo: {
            id: this.props.paymentSessionData.piid,
            parameters: {
              language: this.props.paymentSessionData.language,
              partner: this.props.paymentSessionData.partner,
              market: this.props.paymentSessionData.country,
            },
            resourceType: ResourceTypes.PaymentInstrument,
          },
          riskChallengeData: ['cvv'],
          sessionId: 'dummySessionId', // Value recommended by UST
        };
        this.props.pidlInstance.handlePurchaseRiskChallenge(riskChallengeParams);
      } else {
        this.props.pidlInstance.handlePaymentChallenge(this.props.paymentSessionData);
      }
    }
  }

  renderModern3dsInfoText() {
    if (this.props.paymentSessionData.country === 'IN' && this.props.isModern3ds) {
      return (
        <InlineInfoAlert>
          <div id="3ds-modal-info-text">
            <span>{this.props.modern3dsInfoText}</span>
          </div>
        </InlineInfoAlert>
      );
    }
    return null;
  }

  render() {
    const isPidl3dsTemplatesEnabled = _.get(this.props.permissions, ['dynamic', 'Pidl3dsTemplates'], false);
    return (
      <Modal show={this.props.showModal} onHide={this.props.onHideModalCallbackHandler} backdrop="static" className="sca-challenger-dialog">
        <Modal.Header closeButton>
          <Modal.Title>{this.props.modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div id="sca-challenger-pidl-form-container" className={classnames({ 'pidl-template-migration': isPidl3dsTemplatesEnabled })}>
            <div id={this.props.pidlFormId} />
          </div>
          {this.renderModern3dsInfoText()}
        </Modal.Body>
      </Modal>
    );
  }
}
